import { render, staticRenderFns } from "./user-transaction-tile-v3.vue?vue&type=template&id=bf301a3e"
import script from "./user-transaction-tile-v3.js?vue&type=script&lang=js&external"
export * from "./user-transaction-tile-v3.js?vue&type=script&lang=js&external"
import style0 from "./user-transaction-tile-v3.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports